import Link from 'next/link';
import { User } from '@supabase/supabase-js';
import { IconLogin, IconLogout, IconMail, IconUserCircle } from '@tabler/icons-react';
import { Box, Button, Group } from '@mantine/core';
import { signOutAction } from '@/app/actions/auth';

interface AuthButtonProps {
  user: User | null;
  opened: boolean;
  toggle: () => void;
}

export default function AuthButtons(authButtonProps: AuthButtonProps) {
  const { user, opened, toggle } = authButtonProps;
  const handleAuthAction = async () => {
    if (opened) toggle();
    if (user) {
      await signOutAction();
    } else {
      // Redirect to login page or handle login logic
    }
  };

  const handleDrawerClose = () => {
    if (opened) toggle();
  };

  return (
    <Group m={8}>
      {authButtonProps.user ? (
        <>
          <Button
            mt={4}
            mr={4}
            color="black"
            variant="outline"
            radius="sm"
            onClick={handleAuthAction}
            leftSection={<IconLogout />}
          >
            Log Out
          </Button>
        </>
      ) : (
        <>
          <Button
            color="black"
            variant="outline"
            component={Link}
            href="/sign-in"
            leftSection={<IconLogin />}
            onClick={handleDrawerClose}
          >
            Log In
          </Button>
          {/* <Button
            color="black"
            variant="outline"
            component={Link}
            href="/sign-up"
            leftSection={<IconMail />}
            onClick={handleDrawerClose}
          >
            Sign up
          </Button> */}
        </>
      )}
    </Group>
  );
}
